import { Trans, useLingui } from '@lingui/react/macro'

import { NumberInput, Stack, Text, Textarea } from '@mantine/core'
import { DateInput } from '@mantine/dates'
import { IconCoinEuro } from '@tabler/icons-react'
import { CompletionFormData } from './types'

interface CompletionFormProps {
  data: CompletionFormData
  onChange: (data: CompletionFormData) => void
  errors?: Record<string, string>
  disabled?: boolean
}

export function CompletionForm({
  data,
  onChange,
  errors,
  disabled,
}: CompletionFormProps) {
  const { t } = useLingui()
  const handleFieldChange = (field: keyof CompletionFormData, value: any) => {
    onChange({ ...data, [field]: value })
  }

  return (
    <Stack gap="md">
      <DateInput
        label={<Trans>Work completion date</Trans>}
        placeholder={t`Select date`}
        value={data.completedDate ? new Date(data.completedDate) : new Date()}
        onChange={(value) => {
          // In Mantine v8, DateInput onChange returns a date string (e.g., '2024-01-15')
          handleFieldChange('completedDate', value || '')
        }}
        error={errors?.completedDate}
        required
        disabled={disabled}
      />

      <Textarea
        label={<Trans>Notes</Trans>}
        placeholder={t`Add notes about the completed work...`}
        value={data.notes}
        onChange={(e) => handleFieldChange('notes', e.currentTarget.value)}
        error={errors?.notes}
        minRows={3}
        disabled={disabled}
      />

      <NumberInput
        label={<Trans>Actual cost</Trans>}
        placeholder="0"
        leftSection={<IconCoinEuro size={16} />}
        rightSection={
          <Text size="sm" c="dimmed">
            €
          </Text>
        }
        value={data.actualCost || ''}
        onChange={(value) => handleFieldChange('actualCost', value)}
        min={0}
        max={100000}
        decimalScale={2}
        disabled={disabled}
        description={t`Leave empty if no costs incurred`}
      />
    </Stack>
  )
}
